/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import './Footer.css';
import { useContent } from '../../context/ContentContext';

const Footer = () => {
  const { siteContent } = useContent();

  return (
    <div className="footer">
      <div className="social-media">
        <a href={siteContent.social_instagram_url}>
          <FontAwesomeIcon icon={faInstagram} className="footer-social-media-icon" />
        </a>
        <a href={`mailto:${siteContent.social_email}`}>
          <FontAwesomeIcon icon={faEnvelope} className="footer-social-media-icon" />
        </a>
      </div>
      {siteContent.footer_copyright}
    </div>
  );
};

export default Footer;
